import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./blazeYourTrail.html";
import { WireI18n } from '~/modules/stores/i18nStore';
class BlazeYourTrail extends LightningElement {
  constructor(...args) {
    super(...args);
    this.
    // @ts-expect-error * Automated Type Error Fix
    i18n = void 0;
    this.showModal = false;
    this.urls = {
      learnUrl: 'https://trailhead.salesforce.com/en/content/learn/trails/meet-your-business-needs-with-appexchange',
      shopUrl: 'https://appexchange.salesforce.com/collection/SalesforceLabs',
      connectUrl: 'https://success.salesforce.com/featuredGroupDetail?id=a1z30000006IDZ6AAO#a0L3000000Rq7JgEAJ'
    };
  }
  watchAction() {
    this.showModal = true;
  }
  closeModal() {
    this.showModal = false;
  }
  get lightboxItems() {
    const item = {
      caption: '',
      position: 0,
      src: this.i18n.blazeYourTrail.tourVideoURL,
      type: 'Video',
      videoViewerType: 'iframe',
      shouldAutoPlay: true
    };
    const items = [item];
    return items;
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(BlazeYourTrail, {
  wire: {
    i18n: {
      adapter: WireI18n,
      config: function ($cmp) {
        return {};
      }
    }
  },
  fields: ["showModal", "urls"]
});
const __lwc_component_class_internal = _registerComponent(BlazeYourTrail, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;